module.exports = __webpack_public_path__ + "static/media/PLNflag.838e9038.png";